<div class="job-list">
  <!-- {{ objectSource | json }} -->
  @for (job of jobs; track job; let i = $index) {
    <div class="job">
      <h6> Job ID : <b>{{job.jobId}} </b></h6>
      <h6> Véhicule : <b>{{job.carMake}} {{job.carModel}}, {{job.carYear}} </b></h6>
      <h6> Client: <b>{{job.customerName}}, {{job.customerBusinessName}}</b> </h6>
      <h6> Provider:
        <button matButton class="simple-button"  mat-button (click)="openProviderDialog(job.carId);$event.stopPropagation()">
          <b> {{ job.providerId === '' ? 'no provider': job.providerId }}</b><mat-icon>edit</mat-icon>
        </button>
        <b>{{job.providerName}}, {{job.providerBusinessName}}</b>
      </h6>
      <h6>
        Localisation Client: <b> {{job.customerCity}}, {{getCountryByCode(job.customerCountry)?.name}}</b>
        &nbsp;
        <span class = "mini-flag">
          <img mat-card-image src="assets/images/country-flags/{{job.customerCountry}}.png" alt="{{job.customerCountry}}">
        </span>
      </h6>
      <h6>
        Localisation Provider : <b> {{job.providerCity}}, {{getCountryByCode(job.providerCountry)?.name!}}</b>
        &nbsp;
        <span class = "mini-flag">
          <img mat-card-image src="assets/images/country-flags/{{job.providerCountry}}.png" alt="{{job.providerCountry}}">
        </span>
      </h6>
      <!--
      <mat-form-field>
        <mat-label>Choisir provider</mat-label>
        <mat-select name="selectedProvider" [(ngModel)]="selectedProviderId">
          <mat-option *ngFor="let prov of potentialProviders" [value]="prov" >{{prov}}</mat-option>
        </mat-select>
      </mat-form-field>
      <button class="simple-button" mat-button [disabled]="selectedProviderId === job.providerId || selectedProviderId===''" (click)="updateProvider(job, selectedProviderId)">
        <mat-icon>save</mat-icon>Enrg
      </button> -->
      <h6> Types: <b>{{job.serviceType}} </b> - {{job.jobType}}</h6>
      <h6> Catégories prestations: @for (cat of job.jobCategories; track cat; let i = $index) {
        <b>{{getJobCategoryTitle(cat)}},&nbsp;</b>
      }</h6>
      <h6> Titre: {{job.title}}, Statut: <b>{{job.status}}</b></h6>
      <h6> Description: {{job.description}}</h6>
      <h6> Date activité: <b>{{dateFormat(job.scheduledDate)}}</b></h6>
      <h6> Date création: {{dateFormat(job.created)}}, Dernière mise a jour: {{dateFormat(job.lastUpdated)}}</h6>
      <h6> Rendez vous: @for (appt of job.appointments; track appt; let i = $index) {
        <span>
        {{appt}}, </span>
      }
    </h6>
    <div class="job-buttons">
      @for (actionItem of jobActionItems; track actionItem; let j = $index) {
        <div>
          @if (job.dealerActions?.includes(actionItem.action)) {
            <button
              class="simple-button"  mat-button (click)="executeAction(job, actionItem.action);$event.stopPropagation()">
              {{ actionItem.title }} <mat-icon> {{ actionItem.icon }}</mat-icon>
            </button>
          }
        </div>
      }
    </div>
    <h5>Items
      @if (job.dealerActions?.includes(JobAction.EDIT)) {
        <button
          class="simple-button"  mat-button (click)="openJobItemDialog(job.carId, job.offerId, job.jobId, 0);$event.stopPropagation()">
          <mat-icon>add</mat-icon> Ajouter
        </button>
      }
    </h5>
    @for (item of job.jobItems; track item; let i = $index) {
      <h6>
        ID <b>{{item.jobItemId}}</b>, Titre: <b>({{item.jobTaskId}}) {{item.jobTaskCode}} - {{item.jobTaskTitle}} ({{item.unitAmount}} {{item.currency}})</b>
        @if (job.dealerActions?.includes(JobAction.EDIT)) {
          <button
            class="simple-button"  mat-button (click)="openJobItemDialog(job.carId, job.offerId, job.jobId, item.jobItemId);$event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (job.dealerActions?.includes(JobAction.EDIT)) {
          <button
            class="simple-button"  mat-button (click)="deleteJobItem(item.jobItemId);$event.stopPropagation()">
            <mat-icon>remove</mat-icon>
          </button>
        }
      </h6>
    }
    <!--
    <div class="job-buttons">
      <button *ngIf="(job.status === JobStatus.NEW || job.status === JobStatus.SCHEDULED)"
        class="simple-button"  mat-button (click)="rescheduleJob(job);$event.stopPropagation()">
        Reprg <mat-icon>calendar_month</mat-icon>
      </button>  -->
      <!--
      <button *ngIf="(job.status === JobStatus.NEW || job.status === JobStatus.SCHEDULED)"
        class="simple-button"  mat-button (click)="openJobItemDialog(job.carId, job.offerId, job.jobId, 0);$event.stopPropagation()">
        Ajouter tache <mat-icon>add</mat-icon>
      </button>  -->
      <!--
      <button *ngIf="(job.status === JobStatus.NEW || job.status === JobStatus.SCHEDULED)"
        class="simple-button"  mat-button (click)="openJobDialog(job.carId, job.offerId, job.jobId);$event.stopPropagation()">
        Editer <mat-icon>edit</mat-icon>
      </button>
      <button *ngIf="(job.status === JobStatus.SCHEDULED)"
        class="simple-button"  mat-button (click)="updateJobStatus(job.jobId, JobStatus.COMPLETED);$event.stopPropagation()">
        Completer <mat-icon>accept</mat-icon>
      </button>
      <button *ngIf="(job.status !== JobStatus.CANCELLED)"
        class="simple-button"  mat-button (click)="updateJobStatus(job.jobId, JobStatus.CANCELLED);$event.stopPropagation()">
        Annuler <mat-icon>cancel</mat-icon>
      </button>
    </div>  -->
  </div>
}
</div>
